"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TutorialSlideNav = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<div class="dropup slide-picker">
    <button type="button" class="slide-picker-toggle" @click="${(x, c) => x.toggleMenu(c.event)}" aria-expanded="false">
        <span class="sp-num">${x => x.currentStepIndex === 0 ? 'i' : x.currentStepIndex}</span>
        <span class="sp-text">
            <small>${x => x.currentStepIndex === 0 ? 'tutorial.form.start'.t() : ('tutorial.form.stepCount'.t({ current: x.currentStepIndex, total: x.steps.length }))}</small>
            <strong>${x => { var _a; return x.currentStepIndex === 0 ? x.basicInfoLabel : (((_a = x.steps[x.currentStepIndex - 1]) === null || _a === void 0 ? void 0 : _a.title) || ('tutorial.form.step'.t() + ' ' + x.currentStepIndex)); }}</strong>
        </span>
        <i class="simple-icon-arrow-down sp-caret"></i>
    </button>
    <ul class="dropdown-menu slide-picker-menu">
        <li>
            <button type="button" class="${x => 'dropdown-item slide-item' + (x.currentStepIndex === 0 ? ' active' : '')}"
                @click="${x => x.goToStep(0)}">
                <span class="sp-num"><i class="simple-icon-info"></i></span>
                <span class="sp-text">
                    <strong>${x => x.basicInfoLabel}</strong>
                    <small>${x => x.sectionsLabel}</small>
                </span>
            </button>
        </li>
        ${(0, fast_element_1.when)(x => x.steps.length > 0, (0, fast_element_1.html) `<li><h6 class="dropdown-header">${() => 'tutorial.form.steps'.t()}</h6></li>`)}
        ${(0, fast_element_1.repeat)(x => x.steps, (0, fast_element_1.html) `
        <li>
            <button type="button" class="${(step, c) => 'dropdown-item slide-item' + (c.parent.currentStepIndex === c.index + 1 ? ' active' : '')}"
                @click="${(step, c) => c.parent.goToStep(c.index + 1)}">
                <span class="sp-num">${(step, c) => c.index + 1}</span>
                <span class="sp-text">
                    <strong>${step => step.title || ''}</strong>
                    <small>${(step, c) => 'tutorial.form.sectionsCount'.t({ count: step.sections.length })}</small>
                </span>
            </button>
        </li>
        `, { positioning: true })}
        <li><hr class="dropdown-divider"></li>
        <li>
            <button type="button" class="dropdown-item slide-add" @click="${(x, c) => { console.log('[template addStep click]'); x.addStep(); }}">
                <i class="simple-icon-plus"></i>
                ${() => 'tutorial.form.addStep'.t()}
            </button>
        </li>
    </ul>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: contents;
}

.steps-shortcut-panel {
  position: sticky;
  top: 55px;
  background: var(--color-surface, #fff);
  border: 1px solid #e3e6f0;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 12px;
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.steps-shortcut-panel[hidden] {
  display: none;
}
.steps-shortcut-panel .panel-title {
  font-size: 10px;
  font-weight: 600;
  color: var(--color-text-secondary, #6c757d);
  text-align: center;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.steps-shortcut-panel .panel-divider {
  height: 1px;
  background: #e3e6f0;
  margin: 2px 0;
}
.steps-shortcut-panel .step-shortcut-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 84px;
  padding: 8px 6px;
  border: 1px solid #dee2e6;
  background: var(--color-surface, #fff);
  color: var(--color-text-primary, #495057);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
}
.steps-shortcut-panel .step-shortcut-btn:hover {
  background: #007bff;
  color: #fff;
  border-color: #007bff;
  transform: translateX(2px);
}
.steps-shortcut-panel .step-shortcut-btn:hover .section-count {
  color: #fff;
}
.steps-shortcut-panel .step-shortcut-btn[active] {
  background: var(--primary-color);
  color: #fff;
  border-color: var(--primary-color);
}
.steps-shortcut-panel .step-shortcut-btn[active] .section-count {
  color: #fff;
}
.steps-shortcut-panel .step-shortcut-btn:active {
  transform: translateX(2px) scale(0.95);
}
.steps-shortcut-panel .step-shortcut-btn .step-number {
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}
.steps-shortcut-panel .step-shortcut-btn .section-count {
  font-size: 10px;
  color: var(--color-text-secondary, #6c757d);
  margin-top: 2px;
}
.steps-shortcut-panel .step-shortcut-btn.info-btn .step-number {
  font-size: 11px;
}
.steps-shortcut-panel .add-step-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 84px;
  margin-top: 4px;
  padding: 8px 6px;
  border: 1px dashed #007bff;
  background: #fff;
  color: #007bff;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.steps-shortcut-panel .add-step-btn i {
  font-size: 12px;
}
.steps-shortcut-panel .add-step-btn:hover {
  background: #007bff;
  color: #fff;
}
@media (max-width: 768px) {
  .steps-shortcut-panel {
    position: static;
    flex-direction: row;
    max-height: none;
    overflow-x: auto;
    align-items: stretch;
  }
  .steps-shortcut-panel .step-shortcut-btn,
  .steps-shortcut-panel .add-step-btn,
  .steps-shortcut-panel .section-shortcut-btn {
    flex-shrink: 0;
  }
  .steps-shortcut-panel .add-step-btn {
    margin-top: 0;
  }
  .steps-shortcut-panel .panel-divider {
    width: 1px;
    height: auto;
    flex-shrink: 0;
  }
}

.slide-picker {
  position: relative;
  flex: 0 1 560px;
  min-width: 0;
  display: flex;
  justify-content: center;
}

.slide-picker-toggle {
  width: 100%;
  max-width: 560px;
  height: 48px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 12px 0 9px;
  border: 1px solid var(--brand-border);
  border-radius: 10px;
  background: #fff;
  text-align: left;
  color: var(--ink);
  cursor: pointer;
}
.slide-picker-toggle:hover, .slide-picker-toggle[aria-expanded=true] {
  border-color: var(--brand);
}
.slide-picker-toggle .sp-text {
  flex: 1;
}

.slide-picker-menu {
  display: none;
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  width: 100%;
  max-width: 560px;
  max-height: 60vh;
  overflow-y: auto;
  padding: 6px;
  margin: 0;
  border: 1px solid var(--brand-border);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 -14px 34px -18px rgba(31, 44, 85, 0.35);
  list-style: none;
  z-index: 1050;
}
.slide-picker-menu.show {
  display: block;
}
.slide-picker-menu li {
  list-style: none;
}

.dropdown-header {
  font-size: 0.74rem;
  font-weight: 700;
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 6px 10px 2px;
}

.slide-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  text-align: left;
  color: var(--ink);
  white-space: normal;
  cursor: pointer;
}
.slide-item:hover, .slide-item:focus {
  background: var(--bg);
  color: var(--ink);
}
.slide-item.active, .slide-item:active {
  background: var(--brand-soft);
  color: var(--ink);
}
.slide-item.active .sp-num, .slide-item:active .sp-num {
  background: var(--brand);
  color: #fff;
}

.slide-add {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 9px 12px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  text-align: left;
  color: var(--action);
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
}
.slide-add:hover, .slide-add:focus {
  background: var(--brand-soft);
  color: var(--brand-dark);
}

.sp-num {
  width: 30px;
  height: 30px;
  display: inline-grid;
  place-items: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: var(--brand-soft);
  color: var(--brand-dark);
  font-weight: 700;
  font-size: 0.82rem;
}

.sp-text {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  line-height: 1.25;
}
.sp-text strong {
  font-size: 0.9rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sp-text small {
  color: var(--muted);
  font-size: 0.74rem;
}

.sp-caret {
  color: var(--muted);
  flex-shrink: 0;
}`;
const shadowOptions = { "mode": "open" };
let TutorialSlideNav = class TutorialSlideNav extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.steps = [];
        this.currentStepIndex = 0;
        this.basicInfoLabel = '';
        this.sectionsLabel = '';
        this.addStepLabel = '';
        this.handleOutsideClick = (event) => {
            if (!event.composedPath().includes(this)) {
                this.closeMenu();
            }
        };
    }
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener('click', this.handleOutsideClick);
    }
    disconnectedCallback() {
        document.removeEventListener('click', this.handleOutsideClick);
    }
    toggleMenu(event) {
        var _a;
        event.stopPropagation();
        const menu = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.slide-picker-menu');
        menu === null || menu === void 0 ? void 0 : menu.classList.toggle('show');
    }
    closeMenu() {
        var _a;
        const menu = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.slide-picker-menu');
        menu === null || menu === void 0 ? void 0 : menu.classList.remove('show');
    }
    goToStep(index) {
        this.closeMenu();
        this.$emit('go-to-step', { index });
    }
    addStep() {
        console.log('[slide-nav addStep] clicked, steps.length:', this.steps.length);
        this.closeMenu();
        console.log('[slide-nav addStep] emitting add-step');
        this.$emit('add-step');
        console.log('[slide-nav addStep] emitting go-to-step', this.steps.length + 1);
        this.$emit('go-to-step', { index: this.steps.length + 1 });
    }
};
exports.TutorialSlideNav = TutorialSlideNav;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialSlideNav.prototype, "steps", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], TutorialSlideNav.prototype, "currentStepIndex", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TutorialSlideNav.prototype, "basicInfoLabel", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TutorialSlideNav.prototype, "sectionsLabel", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TutorialSlideNav.prototype, "addStepLabel", void 0);
exports.TutorialSlideNav = TutorialSlideNav = __decorate([
    (0, client_1.RWSView)('tutorial-slide-nav', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], TutorialSlideNav);
TutorialSlideNav.defineComponent();
